import React from 'react'
import ReactDOM from 'react-dom'
import LoginPage from './components/LoginPage';
import LoginOauth from './components/LoginOauth';
import Callback from './components/Callback';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './tailwind.css'
import './style.css'
import Home from './views/home'
import NotFound from './views/NotFound'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route component={LoginOauth} exact path="/login" />
        <Route component={Home} exact path="/" />
        <Route component={Callback} path="/callback" />
        <Route component={NotFound} path="**" />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
